<template>
  <div class="container py-4">

    <div class="modal fade" id="modalError" tabindex="-1" role="dialog" aria-labelledby="modalErrorTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErrorTitle">Ooops...</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            An error occurred, please try again.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <pno-loading :loading="loading">
    
    <br class="d-none d-sm-block">
    <div class="row">
      <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-5">
        <h1 class="h4 mb-1">Request booking</h1>
        <p class="grey">We need a few details to confirm price and availability.</p>
        <hr>
        <form @submit="submit" novalidate>
          <div class="form-group mb-3">
            <label class="small">Name</label>
            <input class="form-control" type="text" :class="errors.fullName ? 'is-invalid' : ''" required v-model="requestForm.fullName">
            <div class="invalid-feedback">
              Please enter your full name
            </div>
          </div>
          <div class="form-group mb-3">
            <label class="small">Email</label>
            <input class="form-control" type="email" :class="errors.email ? 'is-invalid' : ''" required v-model="requestForm.email">
            <div class="invalid-feedback">
              Please enter a valid email
            </div>
          </div>
          <div class="form-group mb-3">
            <label class="small">Phone</label>
            <input class="form-control" type="tel" :class="errors.phone ? 'is-invalid' : ''" required v-model="requestForm.phone">
            <div class="invalid-feedback">
              Please enter your phone number
            </div>
          </div>
          <div class="form-group mb-3">
            <label class="small">Company</label>
            <input class="form-control" :class="errors.companyName ? 'is-invalid' : ''" type="text" required v-model="requestForm.companyName">
            <div class="invalid-feedback">
              Please enter a company name
            </div>
          </div>
          <div class="form-group">
            <label class="small">Country + VAT number</label>
            <input class="form-control" :class="errors.country ? 'is-invalid' : ''" type="text" required v-model="requestForm.country">
            <div class="invalid-feedback">
              Please enter country and VAT number
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-lg btn-success btn-block mb-3">Send booking request</button>
            <small class="form-text grey">By submitting, you agree to the <a href="https://pnorental.com/terms" target="_blank" rel="nofollow">Terms of Use</a> and <a href="https://pnorental.com/privacy" target="_blank" rel="nofollow">Privacy and Cookie Policy</a>.</small>
          </div>
        </form>
      </div>
    </div>
    </pno-loading>
    <br>
  </div>
</template>

<script>
export default {
    mounted() {
      this.$store.commit('meta/title', 'Request price')
    },
    data: () => ({
      requestForm: {},
      loading: false,
      errors: {},
    }),
    computed: {
      quoteItems() {
        return Object.keys(this.$store.state.quote.items)
      },
    },
    methods: {
      validEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      validateForm() {
        const errors = {}
        if (!this.requestForm.companyName) errors.companyName = true
        if (!this.requestForm.country) errors.country = true
        if (!this.requestForm.fullName) errors.fullName = true
        if (!this.requestForm.email) errors.email = true
        if (!this.requestForm.phone) errors.phone = true
        if (!this.validEmail(this.requestForm.email)) errors.email = true
        return errors
      },
      submit(e) {
        e.preventDefault()
        this.errors = this.validateForm()
        if (Object.keys(this.errors).length > 0) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          return
        }
        this.requestQuote()
      },
      async requestQuote() {
        try {
          this.loading = true
          this.requestForm.quote = this.$store.state.quote.items
          await this.$store.dispatch('quote/requestQuote', this.requestForm)
          this.loading = false
          this.$nextTick(() => this.$router.push('/booking/confirmation'))
        }
        catch (error) {
          this.loading = false
          $('#modalError').modal('show')
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }
    }
  }
</script>
